<template>
    <div>
        <!--        <breadcrumb :routerList="[{title:'OEM付款报表 '}]"/>-->
        <Breadtabsheader/>
        <div class="h-content" style="">
            <!-- tab切换 -->
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">

                    <el-tab-pane label="运营会2026" name="first" :key="'first'">
                        <weeklyMeetingList2026   v-if="activeName === 'first'" />
                    </el-tab-pane>
                    <el-tab-pane label="运营会2025" name="second" :key="'second'">
                        <weeklyMeetingList  v-if="activeName === 'second'" />
                    </el-tab-pane>


                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import weeklyMeetingList from './weeklyMeetingList.vue'
import weeklyMeetingList2026 from './weeklyMeetingList2026.vue'
export default {
    components: {
        //Breadcrumb,
        weeklyMeetingList,weeklyMeetingList2026
    },
    data() {
        return {
            // 默认第一个Tab
            activeName: "first",

        };

    },
    created() {
        if(this.$route.query.type){
            this.activeName = this.$route.query.type;
        }

    },
    methods: {
        //tab切换
        handleClick(tab) {




        },

    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
